











import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'cIconWithLabel',
  props: {
    icon: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    return {
      handleClick: (): void => {
        emit('clickIcon');
      },
    };
  },
});
